module.exports = __webpack_public_path__ + "img/Veritas_round.8be807af.png";